<script setup lang="ts">
import {QuickFilter, QuickFilterCategory} from "@/auto-complete-searchbar/interfaces";
import {ref, watch} from "vue";
import {CUSTOMER_SEARCH_QUERY_PARAM_KEYS} from "@/core/interfaces/search-bar/ICustomerSearchBar";

const {selectedFilters} = defineProps<{
    categories: QuickFilterCategory[];
    selectedFilters: QuickFilter<any>[];
}>();
defineEmits<{ (e: 'onFilterPress', filter: QuickFilter<any>) }>();

const filters = ref<QuickFilter<any>[]>(selectedFilters);

watch(() => selectedFilters, (value) => {
    if (value) {
        filters.value = value;
    }
}, {immediate: true});

const isSelected = (filter: QuickFilter<any>): boolean => {
    if (!filters.value) {
        return false;
    }
    return !!filters.value.find(selectedFilter => {
        if (selectedFilter.queryParam === 'age' || selectedFilter.queryParam === CUSTOMER_SEARCH_QUERY_PARAM_KEYS.LAST_VISIT_RANGE) {
            return selectedFilter.queryParam === filter.queryParam &&
                selectedFilter.value.from === filter.value.from &&
                selectedFilter.value.to === filter.value.to;
        }
        return selectedFilter.queryParam === filter.queryParam &&
            selectedFilter.value === filter.value;
    });
};
</script>

<template>
  <div class="space-y-5">
    <div
      v-for="(category, index) in categories"
      :key="index"
    >
      <div class="flex items-center gap-2 mb-3">
        <component
          :is="category.icon"
          v-if="category.icon"
          class="size-4 text-primary"
        />
        <span class="font-semibold text-sm leading-tight">{{ category.name }}</span>
      </div>
      <div class="flex flex-row flex-wrap gap-2">
        <button
          v-for="(filter, categoryIndex) in category.filters"
          :key="`${category.name}-${categoryIndex}`"
          type="button"
          class="px-4 py-1.5 rounded-full border text-sm font-medium transition-colors leading-tight"
          :class="[
            isSelected(filter)
              ? 'bg-primary/10 border-primary/30 text-primary font-semibold'
              : 'bg-white border-border text-foreground hover:bg-muted'
          ]"
          @click="$emit('onFilterPress', filter)"
        >
          {{ filter.label }}
        </button>
      </div>
      <hr v-if="index !== categories.length - 1" class="mt-5">
    </div>
  </div>
</template>
